import { render, staticRenderFns } from "./setingshen.vue?vue&type=template&id=2995b7af&scoped=true&"
import script from "./setingshen.vue?vue&type=script&lang=js&"
export * from "./setingshen.vue?vue&type=script&lang=js&"
import style0 from "./setingshen.vue?vue&type=style&index=0&id=2995b7af&lang=scss&scoped=true&"
import style1 from "./setingshen.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2995b7af",
  null
  
)

export default component.exports